<svg class="icon-delete" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.05556 6.5H8.94444M6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 1 6.5 1C9.53757 1 12 3.46243 12 6.5C12 9.53757 9.53757 12 6.5 12Z" stroke="#FB2D2D" stroke-width="0.928571" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
